import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import styles from './CardContact.module.scss';

const CardContact = ({ name, role, phone, email, image }) => {
    return (
        <div className={styles['CardContact']}>
            <div className={styles['CardContact__Image']}>
                {image && image.image && (
                    <Image maxImageWidth={1020} {...image.image} altText={''} />
                )}
            </div>
            <div className={styles['CardContact__Content']}>
                <div className={styles['CardContact__Name']}>{name}</div>
                <div className={styles['CardContact__Role']}>{role}</div>
                <a
                    className={styles['CardContact__Phone']}
                    href={'tel:' + phone}
                >
                    {phone}
                </a>
                <a
                    className={styles['CardContact__Email']}
                    href={'mailto:' + email}
                >
                    Skicka e-post {'>'}
                </a>
            </div>
        </div>
    );
};

CardContact.propTypes = {
    name: PropTypes.string,
    role: PropTypes.string,
    email: PropTypes.string,
    image: PropTypes.object,
    phone: PropTypes.string,
};

CardContact.defaultProps = {
    name: '',
    role: '',
    email: '',
    image: {},
    phone: '',
};

export default CardContact;
